import * as angular from "angular";
import * as _ from "lodash";
import {AddressesService} from "../../addresses/services/addresses-service.factory";

export class ServicePointsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log, private addressesService: AddressesService) {
  }

  openServicePointDialog(event, mode: 'create' | 'update', servicePoint?) {
    const self = this;
    const isCreate = mode === 'create';
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/service-point-dialog.html').default,
      controller: function ($scope) {
        $scope.title = isCreate ? 'Create Service Point' : 'Edit Service Point';
        $scope.submitLabel = isCreate ? 'Create' : 'Update';

        if (isCreate) {
          $scope.isCustom = false;
          $scope.servicePoint = {
            name: _.get(servicePoint, 'name'),
            externalId: _.get(servicePoint, 'externalId'),
            branchIds: _.get(servicePoint, 'branchIds', []),
            tags: _.get(servicePoint, 'tags'),
            address: _.get(servicePoint, 'address')
          };
        } else {
          $scope.isCustom = !!_.get(servicePoint, 'address.location.lat');
          $scope.servicePoint = angular.copy(servicePoint);
          $scope.servicePoint.branchIds = $scope.servicePoint.branchIds || [];
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddressChange = (address) => {
          $scope.servicePoint.address = address;
        }

        $scope.onToggleCustomAddress = () => {
          $scope.isCustom = !$scope.isCustom;
        }

        $scope.onTagsChange = (tags) => {
          $scope.servicePoint.tags = tags;
        }

        $scope.onLocationSelect = (location) => {
          if (!$scope.servicePoint.address) {
            $scope.servicePoint.address = {}
          }
          $scope.servicePoint.address.location = self.addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.servicePoint);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  openImportServicePointsDialog(event) {
    const self = this;
    return this.$mdDialog.show({
      multiple: true,
      clickOutsideToClose: true,
      parent: angular.element(document.body),
      template: require('./../views/dialogs/import-service-points-dialog.html').default,
      targetEvent: event,
      controller: function ($scope, $timeout, servicePointsRequests, servicePointsAlerts, servicePointsConstants) {
        $scope.file = null;
        $scope.errors = [];
        $scope.importResult = null;
        $scope.loading = false;

        $scope.onDownloadExample = () => {
          const downloadUrl = servicePointsConstants.importSampleFileLink;
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-service-points-example.xls";
          document.body.appendChild(a);
          a.click();
        }

        $scope.onFileChanged = (file) => {
          $scope.file = file;
          $scope.errors = [];
          $scope.importResult = null;

          if ($scope.file) {
            $scope.loading = true;
            servicePointsRequests.validateImport(file)
              .then((data) => {
                $scope.importResult = data;
                const mappingErrors = _.flatMap(data.results || [], item => item.mappingErrors || []);

                $scope.warnings = _.filter(mappingErrors, { type: 'Warning' });
                $scope.errors = _.filter(mappingErrors, { type: 'Error' });
              })
              .catch((error) => {
                self.$log.error('Failed to validate import @servicePointsDialogService@openImportServicePointsDialog', error);
                servicePointsAlerts.validationError();
                $scope.file = null;
              })
              .finally(() => {
                $scope.loading = false;
                $timeout(() => {}, 0);
              });
          }
          $timeout(() => {}, 0);
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          if ($scope.importResult && $scope.importResult.results && $scope.importResult.results.length) {
            $scope.loading = true;
            servicePointsRequests.importServicePoints($scope.importResult.results)
              .then((data) => {
                servicePointsAlerts.importSuccess();
                self.$mdDialog.hide();
              })
              .catch((error) => {
                self.$log.error('Failed to import service points @servicePointsDialogService@openImportServicePointsDialog', error);
                servicePointsAlerts.importError();
              })
              .finally(() => {
                $scope.loading = false;
                $timeout(() => {}, 0);
              });
          }
        };
      }
    });
  }
}

angular
  .module('bringoz.admin.service-points')
  .service('servicePointsDialogService', ServicePointsDialogService);
